module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_02_1280_1280_ko-8831415abf45940a5fc3ac5910ba71c3.jpg";